import {
    HttpHandler,
    HttpRequest,
    HttpEvent,
    HttpErrorResponse,
    HttpInterceptor,
    HttpResponse,
    HttpEventType
} from "@angular/common/http";
import { Observable, from, of, throwError } from "rxjs";
import { catchError, finalize, switchMap, tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { EncryptionService } from "../../dashboard/services/encryption.service";
import { Router } from "@angular/router";
import { BsModalRef } from "ngx-bootstrap/modal";
// import { ErrorHandlerService } from "../../shared/services/error-handler/error-handler.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private _toastr : ToastrService,
        private _encryptionServie: EncryptionService,
        private _router: Router,
        public bsModalRef: BsModalRef,
        ) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((errorRes: HttpEvent<any>) => {
                const error = this._encryptionServie.decryptResponse(errorRes);
                console.log("error", error)
                // if (error) {
                if ((error?.exception?.toLowerCase() === "invalid token" || error?.exception?.toLowerCase() === "invalid session" || error?.error?.exception?.toLowerCase() === "invalid session" || error?.error?.exception?.toLowerCase() === "invalid token")) {
                    localStorage.clear();
                    this.bsModalRef.content?.onClose();
                    this._router.navigateByUrl('/login')
                } else if ((error?.exception && !this.isPOTestRun(error?.exception))) {
                    this._toastr.error(error?.error?.exception || "", error?.error?.message || error?.exception ||error?.message||"Something went wrong, Please try again later!");
                } 
                return throwError(error);
            })
        ) as Observable<HttpEvent<any>>;
    }

    isPOTestRun(exception: any){
        if(exception.includes('Create Purchase Order')){
            return eval(exception).filter((message:any)=> message.MESSAGE.includes("Create Purchase Order")).length == eval(exception)?.length;
        } else {
            return false
        }
    }
}

